import {
    MapContainer,
    TileLayer,
    Marker,
    Popup,
    ZoomControl,
    useMap
} from 'react-leaflet';
import L from 'leaflet';
import { useEffect, useState } from 'react';
import Pusher from 'pusher-js';

import 'leaflet/dist/leaflet.css';

/* Fix para los íconos por defecto de Leaflet en React */
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
    iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

/* Ícono personalizado para vehículos (opcional) */
const busSvg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path d="M192 64C139 64 96 107 96 160L96 448C96 477.8 116.4 502.9 144 510L144 544C144 561.7 158.3 576 176 576L192 576C209.7 576 224 561.7 224 544L224 512L416 512L416 544C416 561.7 430.3 576 448 576L464 576C481.7 576 496 561.7 496 544L496 510C523.6 502.9 544 477.8 544 448L544 160C544 107 501 64 448 64L192 64zM160 240C160 222.3 174.3 208 192 208L296 208L296 320L192 320C174.3 320 160 305.7 160 288L160 240zM344 320L344 208L448 208C465.7 208 480 222.3 480 240L480 288C480 305.7 465.7 320 448 320L344 320zM192 384C209.7 384 224 398.3 224 416C224 433.7 209.7 448 192 448C174.3 448 160 433.7 160 416C160 398.3 174.3 384 192 384zM448 384C465.7 384 480 398.3 480 416C480 433.7 465.7 448 448 448C430.3 448 416 433.7 416 416C416 398.3 430.3 384 448 384zM248 136C248 122.7 258.7 112 272 112L368 112C381.3 112 392 122.7 392 136C392 149.3 381.3 160 368 160L272 160C258.7 160 248 149.3 248 136z"/></svg>
`;

const vehicleIcon = new L.DivIcon({
    html: busSvg,
    iconSize: [32, 32],
    iconAnchor: [16, 16],
    popupAnchor: [0, -16],
    className: 'custom-bus-icon'
});

/* Componente interno para ajustar vista del mapa */
function ChangeView({ center, zoom }) {
    const map = useMap();

    useEffect(() => {
        setTimeout(() => {
            map.invalidateSize({ animate: true });
        }, 400);

        if (center) {
            map.setView(center, zoom);
        }
    }, [center, zoom, map]);

    return null;
}

export default function TransporteCrianza() {
    const [vehiculo, setVehiculo] = useState(null);
    const [mapCenter, setMapCenter] = useState([-36.6167, -64.2833]);
    const [mapZoom, setMapZoom] = useState(15);

    useEffect(() => {
        const pusher = new Pusher("9452ce314d189aed73b9", {
            cluster: "us2",
        });

        const channel = pusher.subscribe("CRIANZA");

        const handleEvent = (data) => {
            const patente = "AG649KL";
            if (Array.isArray(data)) {
                const vehiculoEncontrado = data.find(vehiculo => vehiculo.patente === patente)

                console.log(vehiculoEncontrado)
                setVehiculo(vehiculoEncontrado);
                setMapCenter([vehiculoEncontrado.latitud, vehiculoEncontrado.longitud]);
            }
        };

        channel.bind("alltrack-vehiculos", handleEvent);

        // Cleanup
        return () => {
            channel.unbind("alltrack-vehiculos", handleEvent);
            pusher.unsubscribe("CRIANZA");
            pusher.disconnect();
        };
    }, []);

    if (vehiculo === null) {
        return <p>Esperando datos...</p>
    }

    return (
        <div style={{ height: '100%', width: '100%', background: '#000' }}>
            <MapContainer
                center={mapCenter}
                zoom={mapZoom}
                style={{ height: '100%', width: '100%' }}
                scrollWheelZoom={true}
                zoomControl={false}
            >
                <TileLayer
                    attribution="&copy; OpenStreetMap"
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />

                <ZoomControl position="bottomright" />

                <ChangeView center={mapCenter} zoom={mapZoom} />

                {/* Renderizar vehículos */}
                {vehiculo?.latitud && vehiculo?.longitud &&
                    <Marker
                        key={vehiculo.patente}
                        position={[vehiculo.latitud, vehiculo.longitud]}
                        icon={vehicleIcon}
                    >
                    </Marker>
                }
            </MapContainer>

            {/* Contador de vehículos (opcional) */}
            <div style={{
                position: 'absolute',
                top: '10px',
                left: '10px',
                background: 'rgba(255, 255, 255, 0.9)',
                padding: '10px 15px',
                borderRadius: '5px',
                zIndex: 1000,
                fontWeight: 'bold'
            }}>
                {vehiculo.nombre}: {vehiculo.speed} km/h
            </div>
        </div>
    );
}